const CHAT_STATE_KEY = 'cotera:agent-chat-state';

interface StoredChatState {
  chatId: string;
  timestamp: number;
}

/**
 * Save chatId before navigation. Messages will be fetched from the server.
 */
export function saveAgentChatId(agentName: string, chatId: string): void {
  try {
    const state: StoredChatState = { chatId, timestamp: Date.now() };
    sessionStorage.setItem(
      `${CHAT_STATE_KEY}:${agentName}`,
      JSON.stringify(state)
    );
  } catch {
    // Ignore storage errors
  }
}

/**
 * Load preserved chatId. Returns null if not found or expired.
 */
export function loadAgentChatId(agentName: string): string | null {
  const key = `${CHAT_STATE_KEY}:${agentName}`;
  try {
    const stored = sessionStorage.getItem(key);
    if (stored === null) {
      return null;
    }

    const parsed: StoredChatState = JSON.parse(stored);

    // Expire after 10 seconds
    if (Date.now() - parsed.timestamp > 10000) {
      sessionStorage.removeItem(key);
      return null;
    }

    // Don't remove immediately - let it expire naturally
    // This handles React double-renders

    return parsed.chatId;
  } catch {
    return null;
  }
}
